import { render, staticRenderFns } from "./BuscaPorCodigo.vue?vue&type=template&id=28523ff2&scoped=true&"
import script from "./BuscaPorCodigo.vue?vue&type=script&lang=js&"
export * from "./BuscaPorCodigo.vue?vue&type=script&lang=js&"
import style0 from "./BuscaPorCodigo.vue?vue&type=style&index=0&id=28523ff2&prod&lang=css&"
import style1 from "./BuscaPorCodigo.vue?vue&type=style&index=1&id=28523ff2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28523ff2",
  null
  
)

export default component.exports